// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brands-carousel-item {
  opacity: 0.5;
  transition: opacity 500ms ease-in-out;
}
.brands-carousel-item__img {
  display: block;
  width: 100%;
  height: 100%;
  height: 510px;
  object-fit: cover;
  border-radius: 0.75rem;
}
@media (max-width: 2048px) {
  .brands-carousel-item__img {
    height: 488px;
  }
}
@media (max-width: 1792px) {
  .brands-carousel-item__img {
    height: 424px;
  }
}
@media (max-width: 1536px) {
  .brands-carousel-item__img {
    height: 414px;
  }
}
@media (max-width: 1344px) {
  .brands-carousel-item__img {
    height: 360px;
  }
}
@media (max-width: 1152px) {
  .brands-carousel-item__img {
    height: 305px;
  }
}
@media (max-width: 900px) {
  .brands-carousel-item__img {
    height: 240px;
  }
}
.brands-carousel-item__name {
  font-family: var(--merriweather);
  text-align: center;
  margin-top: 1rem;
  font-weight: 300;
  font-size: 1.25rem;
  line-height: 1.6;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .brands-carousel-item__name {
    font-size: 0.875rem;
    line-height: 1.57;
    margin-top: 0.5rem;
  }
}
.brands-carousel-item_visited {
  opacity: 1;
}

.brands-carousel-swiper {
  position: relative;
  margin-bottom: 7.5rem;
  width: 100%;
  height: 100%;
}
@media (max-width: 768px) {
  .brands-carousel-swiper {
    margin-bottom: 4.375rem;
  }
}
.brands-carousel-swiper:hover .swiper-nav-button {
  opacity: 1;
}
.brands-carousel-swiper__spinner {
  margin: 5rem auto;
}`, "",{"version":3,"sources":["webpack://./src/components/BrandsCarousel/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qCAAA;AACF;AACE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AACJ;AACI;EARF;IASI,aAAA;EAEJ;AACF;AAAI;EAZF;IAaI,aAAA;EAGJ;AACF;AADI;EAhBF;IAiBI,aAAA;EAIJ;AACF;AAFI;EApBF;IAqBI,aAAA;EAKJ;AACF;AAHI;EAxBF;IAyBI,aAAA;EAMJ;AACF;AAJI;EA5BF;IA6BI,aAAA;EAOJ;AACF;AAJE;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;AAMJ;AAJI;EATF;IAUI,mBAAA;IACA,iBAAA;IACA,kBAAA;EAOJ;AACF;AAJE;EACE,UAAA;AAMJ;;AAFA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAKF;AAHE;EANF;IAOI,uBAAA;EAMF;AACF;AAJE;EACE,UAAA;AAMJ;AAHE;EACE,iBAAA;AAKJ","sourcesContent":[".brands-carousel-item {\n  opacity: 0.5;\n  transition: opacity 500ms ease-in-out;\n\n  &__img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    height: 510px;\n    object-fit: cover;\n    border-radius: 0.75rem;\n\n    @media (max-width: 2048px) {\n      height: 488px;\n    }\n\n    @media (max-width: 1792px) {\n      height: 424px;\n    }\n\n    @media (max-width: 1536px) {\n      height: 414px;\n    }\n\n    @media (max-width: 1344px) {\n      height: 360px;\n    }\n\n    @media (max-width: 1152px) {\n      height: 305px;\n    }\n\n    @media (max-width: 900px) {\n      height: 240px;\n    }\n  }\n\n  &__name {\n    font-family: var(--merriweather);\n    text-align: center;\n    margin-top: 1rem;\n    font-weight: 300;\n    font-size: 1.25rem;\n    line-height: 1.6;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 0.875rem;\n      line-height: 1.57;\n      margin-top: 0.5rem;\n    }\n  }\n\n  &_visited {\n    opacity: 1;\n  }\n}\n\n.brands-carousel-swiper {\n  position: relative;\n  margin-bottom: 7.5rem;\n  width: 100%;\n  height: 100%;\n\n  @media (max-width: 768px) {\n    margin-bottom: 4.375rem;\n  }\n\n  &:hover .swiper-nav-button {\n    opacity: 1;\n  }\n\n  &__spinner {\n    margin: 5rem auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
